"use client";

import { FeatureFlagContext } from "components/FeatureFlagContext";
import { TrackingWrapper } from "components/trackEvent";
import { SetFeatureFlags } from "./types";

const ClientSideProviders = ({
  featureFlags,
  evaluatedFeatureFlagsHash,
  children,
}: {
  children: React.ReactNode;

  featureFlags: SetFeatureFlags;
  evaluatedFeatureFlagsHash: string;
}) => {
  return (
    <TrackingWrapper>
      <FeatureFlagContext.Provider
        value={{ featureFlags, evaluatedFeatureFlagsHash }}
      >
        {children}
      </FeatureFlagContext.Provider>
    </TrackingWrapper>
  );
};

export default ClientSideProviders;
